export const COMIC_EPISODE_DRAG_MIME = 'application/x-glyphic-comic-episode-id'

export function setComicEpisodeDragData(dataTransfer: DataTransfer, episodeId: string): void {
  dataTransfer.setData(COMIC_EPISODE_DRAG_MIME, episodeId)
  dataTransfer.effectAllowed = 'move'
}

export function readComicEpisodeDragId(dataTransfer: DataTransfer): string | null {
  const id = dataTransfer.getData(COMIC_EPISODE_DRAG_MIME)
  return id || null
}
